import { gql } from '@apollo/client';

const GET_PROFILE = gql`
  query GetProfile {
    profile {
      id
      firstName
      lastName
      address {
        street
        locality
        region
        country
        postalCode
        formatted
        lat
        lng
      }
      introduction
    }
  }
`;

const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      firstName
      lastName
    }
  }
`;

export { GET_PROFILE, UPDATE_PROFILE };
